<template>
    <div class="o-mobile-guide-steps mobile-guide-steps">
        <div
            v-if="overlay"
            class="mobile-guide-steps__overlay"
        >
            <AButton
                class="mobile-guide-steps__overlay-button"
                @onClick="focusOnCurrentStep(activeStepIndex)"
            >
                <template #left>
                    <svg-icon
                        original
                        name="icons/compass-shape"
                        class="mobile-guide-steps__overlay-button-icon"
                    />
                </template>
            </AButton>
        </div>
        <div class="mobile-guide-steps__current-step-container">
            <div class="mobile-guide-steps__current-step-wrapper">
                <span class="mobile-guide-steps__index">
                    {{ activeStepIndex + 1 }}
                </span>
                <svg-icon
                    original
                    :name="`navigation/${activeStep.direction}-black`"
                    class="mobile-guide-steps__icon"
                />
                <OStepText :step="activeStep" />
                <span class="mobile-guide-steps__distance">
                    {{ activeStep.distance }} {{ $t('ui.meter') }}
                </span>
            </div>
        </div>
        <div class="mobile-guide-steps__switchers">
            <button
                type="button"
                role="button"
                class="mobile-guide-steps__switcher mobile-guide-steps__switcher--left"
                :disabled="isDisabledPrevious"
                @click="prevStep"
            >
                <svg-icon
                    original
                    name="icons/arrow-left"
                    class="mobile-guide-steps__switcher-icon mobile-guide-steps__switcher-icon--left"
                />
                <span class="mobile-guide-steps__switcher-text">
                    {{ $t('ui.previous') }}
                </span>
            </button>
            <span class="mobile-guide-steps__step-index">
                {{ activeStepIndex + 1 }}({{ path.length }})
            </span>
            <button
                type="button"
                role="button"
                class="mobile-guide-steps__switcher mobile-guide-steps__switcher--right"
                :disabled="isDisabledNext"
                @click="nextStep"
            >
                <span class="mobile-guide-steps__switcher-text">
                    {{ $t('ui.next') }}
                </span>
                <svg-icon
                    original
                    name="icons/arrow-right"
                    class="mobile-guide-steps__switcher-icon mobile-guide-steps__switcher-icon--right"
                />
            </button>
        </div>
    </div>
</template>

<script>
import {
    mapState,
    mapMutations
} from 'vuex';

import AButton from '../../atoms/a-button/a-button';
import OStepText from '../../unique-organisms/o-step-text/o-step-text';

import {
    UI_STEP_SELECTED,
    MAP_SHOW_PATH_STEPS,
    UI_MAP_CLICKED
} from "../../../shared/components/map-viewer/constants/map-events";
import { REBUILD_PATH } from '../../../utils/constants/bus-events-constants';

export default {
    name: 'OMobileGuideSteps',
    components: {
        AButton,
        OStepText
    },
    data() {
        return {
            overlay: false
        }
    },
    computed: {
        ...mapState({
            path: state => state.activePath?.steps,
            activeStep: state => state.activeStep,
            isLandscape: state => state.landscape,
            activeStepIndex: state => state.activeStepIndex
        }),
        isDisabledNext() {
            return Boolean(this.path.length === (this.activeStepIndex + 1));
        },
        isDisabledPrevious() {
            return Boolean(this.activeStepIndex === 0);
        }
    },
    created() {
        this.checkActiveStep();
    },
    mounted() {
        this.initEventsListeners();
        this.setMobileGuideStartActivate(false);
        this.focusOnCurrentStep(this.activeStepIndex);
    },
    updated() {
        this.alignSwitchers();
    },
    beforeDestroy() {
        this.deactivateEventListeners();
        this.$store.commit('setActiveStepIndex', null);
        this.$store.commit('setActiveStep', null);
    },
    watch: {
        isLandscape() {
            this.alignSwitchers();
        },
        overlay(value) {
            this.$emit('resetGuideShow', value )
        }
    },
    methods: {
        ...mapMutations(['setMobileGuideStartActivate']),
        checkActiveStep() {
            if (this.activeStepIndex === null) {
                this.$store.commit('setActiveStepIndex', 0);
                this.$store.commit('setActiveStep', this.path[this.activeStepIndex]);
            }
        },
        initEventsListeners() {
            this.$bus.$on(UI_MAP_CLICKED, this.centerMap);
            this.$bus.$on(MAP_SHOW_PATH_STEPS, this.changeStep);
            this.$bus.$on(UI_STEP_SELECTED, this.focusOnCurrentStep);
        },
        deactivateEventListeners() {
            this.$bus.$off(UI_MAP_CLICKED, this.centerMap);
            this.$bus.$off(MAP_SHOW_PATH_STEPS, this.changeStep);
            this.$bus.$off(UI_STEP_SELECTED, this.focusOnCurrentStep);
        },
        nextStep() {
            if (this.activeStepIndex === this.path.length - 1) return;
            this.$store.commit('setActiveStepIndex', this.activeStepIndex + 1);
            this.$store.commit('setActiveStep', this.path[this.activeStepIndex]);
            this.focusOnCurrentStep(this.activeStepIndex);
        },
        prevStep() {
            if (this.activeStepIndex === 0) return;
            this.$store.commit('setActiveStepIndex', this.activeStepIndex - 1);
            this.$store.commit('setActiveStep', this.path[this.activeStepIndex]);
            this.focusOnCurrentStep(this.activeStepIndex);
        },
        alignSwitchers() {
            const arr = [...document.getElementsByClassName('mobile-guide-steps__switcher')];
            const values = [];

            arr.forEach(item => {
                values.push(parseInt(item.offsetWidth));
            });

            arr.forEach(item => {
                item.style.width = Math.max(...values) + 'px';
            });
        },
        onClose() {
            this.$store.commit('setActiveStepIndex', null);
            this.$store.commit('setActiveStep', null);
            this.$emit('onClose', true);
            this.$bus.$emit(REBUILD_PATH, true);
        },
        focusOnCurrentStep(step) {
            this.$bus.$emit(MAP_SHOW_PATH_STEPS, step);
            this.overlay = false;
        },
        changeStep(step) {
            this.$store.commit('setActiveStepIndex', step);
            this.$store.commit('setActiveStep', this.path[this.activeStepIndex]);
        },
        centerMap() {
            this.overlay = true;
        }
    }
}
</script>

<style lang="scss">
@import "o-mobile-guide-steps";
</style>
